<template>
	<Head title="Email Verification" />

	<jet-authentication-card>
		<!-- <template #logo>
			<jet-authentication-card-logo />
		</template> -->

		<div class="mb-4 text-sm text-gray-600">
			Vielen Dank für die Registrierung! Könnten Sie bitte Ihre E-Mail-Adresse
			bestätigen, bevor Sie beginnen? Bitte klicken Sie auf den Link, den wir
			Ihnen gerade per E-Mail zugeschickt haben. Sollten Sie die E-Mail nicht
			erhalten haben, senden wir Ihnen gerne eine weitere zu.
		</div>

		<div
			class="mb-4 text-sm font-medium text-green-600"
			v-if="verificationLinkSent"
		>
			Ein neuer Bestätigungslink wurde an die von Ihnen angegebene
			E-Mail-Adresse gesendet während der Anmeldung.
		</div>

		<form @submit.prevent="submit">
			<div class="mt-4 flex items-center justify-between">
				<jet-button
					:class="{ 'opacity-25': form.processing }"
					:disabled="form.processing"
				>
					Bestätigungsmail erneut senden
				</jet-button>

				<Link
					:href="route('logout')"
					method="post"
					as="button"
					class="text-sm text-gray-600 underline hover:text-gray-900"
					>Log Out</Link
				>
			</div>
		</form>
	</jet-authentication-card>
</template>

<script>
import JetAuthenticationCard from "@/Jetstream/AuthenticationCard.vue";
import JetAuthenticationCardLogo from "@/Jetstream/AuthenticationCardLogo.vue";
import JetButton from "@/Jetstream/Button.vue";
import { Head, Link } from "@inertiajs/inertia-vue3";

export default {
	components: {
		Head,
		JetAuthenticationCard,
		JetAuthenticationCardLogo,
		JetButton,
		Link,
	},

	props: {
		status: String,
	},

	data() {
		return {
			form: this.$inertia.form(),
		};
	},

	methods: {
		submit() {
			this.form.post(this.route("verification.send"));
		},
	},

	computed: {
		verificationLinkSent() {
			return this.status === "verification-link-sent";
		},
	},
};
</script>
